import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { styled } from '@leagueplatform/genesis-core';
import {
  DFD_WIDGET_GUTTER,
  DfdEmbedFrame,
} from 'components/dfd-embed-frame/dfd-embed-frame.component';
import { IframeModal } from 'components/modals/common/iframe-modal.component';
import { useDfdEmbedTarget } from 'hooks/use-dfd-embed-target.hook';

const ChatIframe = styled(DfdEmbedFrame, {
  border: 'none',
});

export const ChatSupportModal = ({ onClose }: { onClose: () => void }) => {
  const { formatMessage } = useIntl();

  const modalTitle = formatMessage({ id: 'STR_CHAT_SUPPORT_MODAL_TITLE' });
  const embedTarget = useDfdEmbedTarget();

  return (
    <IframeModal title={modalTitle} onClose={onClose}>
      <ChatIframe
        id="chatSupportModal"
        title={modalTitle}
        {...embedTarget}
        css={
          embedTarget.widgetId ? { '@mobile': DFD_WIDGET_GUTTER } : undefined
        }
      />
    </IframeModal>
  );
};
